// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"057f80d4","453":"419a5d54","732":"3fba199a"}[chunkId] + ".chunk.js";
};